import store from '@/state/store'

export default [
  {
    path: '/metrics',
    name: 'default',
    meta: {
      authRequired: true,
      product: 'live'
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/live-shopping-analyze',
    name: 'default',
    meta: {
      authRequired: true,
      product: 'live'
    },
    component: () => import('./views/dashboards/live-shopping-analyze'),
  },
  
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/dashboard-v2'),
  },
  {
    path: '/users',
    name: 'users',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/users/users'),
  },
  {
    path: '/items-analyze',
    name: 'items-analyze',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/dashboards/items-analyze'),
  },
  {
    path: '/items',
    name: 'items',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/catalogs/items'),
  },
  {
    path: '/integrations',
    name: 'integrations',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/projects/integrations'),
  },
  {
    path: '/gopersonal-auto',
    name: 'gopersonal-auto',
    meta: {
      authRequired: true,
      roles: ['admin'],
    },
    component: () => import('./views/gopersonal-auto/goals'),
  },
  {
    path: '/gopersonal-auto/goals/:id',
    name: 'gopersonal-auto-goal',
    meta: {
      authRequired: true,
      roles: ['admin'],
    },
    component: () => import('./views/gopersonal-auto/goal'),
  },
  {
    path: '/calvin-tasks',
    name: 'calvin-tasks',
    meta: {
      authRequired: true,
      roles: ['admin'],
    },
    component: () => import('./views/calvin/calvin-tasks'),
  },
  {
    path: '/customers',
    name: 'customers',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/customers/customers-v2'),
  },
  {
    path: '/hosts',
    name: 'hosts',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin']
    },
    component: () => import('./views/users/hosts'),
  },
  {
    path: '/groups',
    name: 'groups',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin']
    },
    component: () => import('./views/groups/groups'),
  },
  {
    path: '/tenants',
    name: 'tenants',
    meta: {
      authRequired: true,
      roles:['superadmin']
    },
    component: () => import('./views/users/users'),
  },
  {
    path: '/availability',
    name: 'availability',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin']
    },
    component: () => import('./views/availability/availability'),
  },
  {
    path: '/campaigns',
    name: 'campaigns',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin','host']
    },
    component: () => import('./views/campaigns/campaigns'),
  },
  {
    path: '/events',
    name: 'events',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin','host']
    },
    component: () => import('./views/events/events'),
  },
  {
    path: '/next-events',
    name: 'next-events',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['host']
    },
    component: () => import('./views/events/next-events'),
  },
  {
    path: '/events-list',
    name: 'events-list',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin']
    },
    component: () => import('./views/events/list'),
  },
  {
    path: '/campaign',
    name: 'newCampaign',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin','host']
    },
    component: () => import('./views/campaigns/campaign'),
  },
  {
    path: '/videos',
    name: 'videos',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin']
    },
    component: () => import('./views/videos/videos'),
  },
  {
    path: '/shows',
    name: 'shows',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin']
    },
    component: () => import('./views/events/shows'),
  },
  {
    path: '/new-video',
    name: 'newVideo',
    meta: {
      authRequired: true,
      product: 'live',
      roles:['admin','host']
    },
    component: () => import('./views/videos/new-video'),
  },
  {
    path: '/search',
    name: 'search',
    meta: {
      layout: false,
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./layouts/vertical'),
  },
  {
    path: '/search-settings',
    name: 'search-settings',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/projects/search/settings'),
  },
  {
    path: '/search-analyze',
    name: 'search-analyze',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/projects/search/search-analyze'),
  },
  {
    path: '/search-analyze-v2',
    name: 'search-analyze-v2',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/dashboards/search-v2'),
  },
  {
    path: '/broadcast-analyze',
    name: 'broadcast-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/broadcasts'),
  },
  {
    path: '/broadcast-analyze-v2',
    name: 'broadcast-analyze-v2',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/broadcasts-v2'),
  },
  {
    path: '/transactional-emails',
    name: 'transactional-emails',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/transactional-emails'),
  },
  {
    path: '/journey-analyze',
    name: 'journey-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/journeys'),
  },
  {
    path: '/journey-analyze-v2',
    name: 'journey-analyze-v2',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/journeys-v2'),
  },
  {
    path: '/search-improvements',
    name: 'search-improvements',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/projects/search/search-improvements'),
  },
  {
    path: '/search-clusters',
    name: 'search-clusters',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/projects/search/search-clusters'),
  },
  {
    path: '/search-list',
    name: 'search-list',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/projects/search/list'),
  },
  {
    path: '/search-test',
    name: 'search-test',
    meta: {
      authRequired: true,
      product: 'search',
      roles:['admin']
    },
    component: () => import('./views/projects/search/search-test'),
  },
  {
    path: '/projects',
    name: 'projects',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/projects/projects'),
  },
  {
    path: '/segmentation',
    name: 'segmentation',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/segmentation/rfm.vue'),
  },
  {
    path: '/new-project',
    name: 'new_project',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/projects/new-project'),
  },
  {
    path: '/reco-project',
    name: 'reco-project',
    meta: {
      authRequired: true,
      product: 'reco',
      roles:['admin']
    },
    component: () => import('./views/projects/reco/reco-project'),
  },
  {
    path: '/reco-analyze',
    name: 'reco-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/recommendations'),
  },
  {
    path: '/reco-analyze-v2',
    name: 'reco-analyze-v2',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/recommendations-v2'),
  },
  {
    path: '/project-analyze',
    name: 'project-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/interactions'),
  },
  {
    path: '/personal-analyze',
    name: 'personal-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/personalizations'),
  },
  {
    path: '/personal-analyze-v2',
    name: 'personal-analyze-v2',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/personalizations-v2'),
  },
  {
    // Métricas custom de un content (eventos de gsSDK.track, vía /api/event-analytics)
    path: '/custom-events-analyze',
    name: 'custom-events-analyze',
    meta: { authRequired: true, product: 'personal', roles:['admin'] },
    component: () => import('./views/dashboards/custom-events'),
  },
  {
    path: '/feedback-analyze',
    name: 'feedback-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/feedback'),
  },
  {
    path: '/surveys-analyze',
    name: 'surveys-analyze',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/surveys'),
  },
  {
    path: '/usage',
    name: 'usage',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/dashboards/usage'),
  },
  {
    path: '/custom-strategies',
    name: 'custom-strategies',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/recommendations/custom-strategies'),
  },
  {
    path: '/reco-tester',
    name: 'reco-tester',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/recommendations/reco-tester'),
  },
  {
    path: '/personal-shoppers',
    name: 'personal-shoppers',
    meta: {
      authRequired: true,
      product: 'personal_shopper',
      roles:['admin']
    },
    component: () => import('./views/personal-shopper/personal-shoppers'),
  },
  {
    path: '/shopper',
    name: 'shopper',
    meta: { authRequired: true, product: 'personal_shopper', roles: ['admin', 'super_admin'] },
    component: () => import('./views/personal-shopper/shopper'),
  },
  {
    path: '/personal-shopper',
    name: 'personal-shopper',
    meta: {
      authRequired: true,
      product: 'personal_shopper',
      roles:['admin']
    },
    component: () => import('./views/personal-shopper/personal-shopper'),
  },
  {
    path: '/personal-shopper-analyze',
    name: 'personal-shopper-analyze',
    meta: {
      authRequired: true,
      product: 'personal_shopper',
      roles:['admin']
    },
    component: () => import('./views/personal-shopper/dashboard'),
  },
  
  {
    path: '/custom-strategy',
    name: 'custom-strategy',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/recommendations/custom-strategy'),
  },
  {
    path: '/audiences',
    name: 'audiences',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/audiences/audiences'),
  },
  {
    path: '/audiences-explorer',
    name: 'audiences-explorer',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/audiences/audience-explorer'),
  },
  {
    path: '/contact-lists',
    name: 'contact-lists',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/audiences/contact-lists'),
  },
  {
    path: '/contact-list',
    name: 'contact-list',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/audiences/contact-list'),
  },
  {
    path: '/audience/:id',
    name: 'edit-audience',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/audiences/audience'),
  },
  {
    path: '/audience',
    name: 'audience',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/audiences/audience'),
  },
  {
    path: '/personalizations',
    name: 'personalizations',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/personalizations/personalizations'),
  },
  {
    path: '/personalization',
    name: 'personalization',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/personalizations/personalization'),
  },
  {
    path: '/personalization-preview',
    name: 'personalization-preview',
    meta: {
      layout: false,
      authRequired: false,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/personalizations/preview'),
  },
  {
    path: '/template',
    name: 'template',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/template'),
  },
  {
    path: '/email-components',
    name: 'email-components',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/email-components'),
  },
  {
    path: '/properties',
    name: 'properties',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/properties'),
  },
  {
    path: '/property-groups',
    name: 'property-groups',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/property-groups'),
  },
  {
    path: '/templates',
    name: 'templates',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/templates'),
  },
  {
    path: '/interactions',
    name: 'interactions',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/interactions'),
  },
  {
    path: '/goals',
    name: 'goals',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/goals'),
  },
  {
    path: '/exports',
    name: 'exports',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/exports'),
  },
  {
    path: '/templates-store',
    name: 'templates-store',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/templates-store'),
  },
  {
    path: '/gp-templates-store',
    name: 'gp-templates-store',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/catalogs/gp-templates-store'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('./views/account/profile'),
    meta: {
      authRequired: true,
      roles:['admin','host'],
    },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('./views/projects/settings'),
    meta: {
      authRequired: true,
      roles:['admin'],
    },
  },
  {
    path: '/company',
    name: 'Company',
    component: () => import('./views/account/company'),
    meta: {
      authRequired: true,
      roles:['admin'],
    },
  },
  {
    path: '/journey',
    name: 'journey',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/journeys/journey'),
  },
  {
    path: '/journeys',
    name: 'journeys',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/journeys/journeys'),
  },
  {
    path: '/broadcasts',
    name: 'broadcasts',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/broadcast/broadcasts'),
  },
  {
    path: '/loyalty',
    name: 'loyalty-locked',
    meta: {
      authRequired: true,
      roles:['admin']
    },
    component: () => import('./views/loyalty/locked'),
  },
  {
    path: '/loyalty-dashboard',
    name: 'loyalty-dashboard',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/dashboard'),
  },
  {
    path: '/loyalty-programs',
    name: 'loyalty-programs',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/programs'),
  },
  {
    path: '/loyalty-levels',
    name: 'loyalty-levels',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/levels'),
  },
  {
    path: '/loyalty-campaigns',
    name: 'loyalty-campaigns',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/campaigns'),
  },
  {
    path: '/loyalty-members',
    name: 'loyalty-members',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/members'),
  },
  {
    path: '/loyalty-program',
    name: 'edit-loyalty-program',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/program'),
  },
  {
    path: '/loyalty-movements',
    name: 'loyalty-movements',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/transactions'),
  },
  {
    path: '/loyalty-rewards',
    name: 'loyalty-rewards',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/rewards'),
  },
  {
    path: '/loyalty-vouchers',
    name: 'loyalty-vouchers',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/vouchers'),
  },
  {
    path: '/loyalty-simulator',
    name: 'loyalty-simulator',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/simulator'),
  },
  {
    path: '/loyalty-campaign',
    name: 'edit-loyalty-campaign',
    meta: {
      authRequired: true,
      product: 'loyalty',
      roles:['admin']
    },
    component: () => import('./views/loyalty/campaign'),
  },
  {
    path: '/broadcast',
    name: 'broadcast',
    meta: {
      authRequired: true,
      product: 'personal',
      roles:['admin']
    },
    component: () => import('./views/broadcast/broadcast'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      layout: false,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/select-company',
    name: 'select-company',
    meta: {
      layout: false,
      authRequired: true,
    },
    component: () => import('./views/account/select-company'),
  },
  {
    path: '/verify-device',
    name: 'verify-device',
    meta: { layout: false },
    component: () => import('./views/account/verify-device'),
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      layout: false,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      layout: false,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    // Public on purpose, even with a session open: the emailed one-time token is
    // the credential and the page swaps the session for the invitee's
    path: '/accept-invite',
    name: 'Accept invite',
    meta: {
      layout: false,
    },
    component: () => import('./views/account/accept-invite'),
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        
        store.dispatch('auth/logOut').then(()=>{
          // Navigate back to previous page, or home as a fallback
          next({ path: 'login' })
        });
      },
    },
  },
  {
    path: '/404',
    name: '404',
    meta: {
      layout: false,
    },
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  
]
